/**
 * Generated from platform/mapping-service/data/company_taxonomy.json.
 * Run platform/export/taxonomyconstantsexport.py to update.
 */
import React from 'react';
import {
  FaBroadcastTower, FaBuilding, FaChartBar, FaCode, FaCog, FaCoins, FaCreditCard, FaDatabase, FaDesktop, FaEllipsisH, FaFileInvoice, FaGraduationCap, FaHammer, FaHandshake, FaIndustry, FaLaptopCode, FaMedkit, FaMoneyBillWave, FaNetworkWired, FaRobot, FaServer, FaShieldAlt, FaStore, FaUniversity, FaUsers
} from 'react-icons/fa';

export const DEFAULT_CATEGORY_ICON = FaEllipsisH;

export const CATEGORY_GROUP_ICON_COMPONENTS = {
  "Software": FaLaptopCode,
  "Infrastructure Software": FaDatabase,
  "Data Platforms": FaDatabase,
  "DevOps & Platforms": FaCode,
  "Integration & APIs": FaNetworkWired,
  "Security & IT Management": FaShieldAlt,
  "Cloud & Edge": FaServer,
  "AI Infrastructure": FaRobot,
  "Application Software": FaDesktop,
  "Workflow & Work Management": FaCog,
  "CRM & Customer Engagement": FaStore,
  "Productivity & Content": FaDesktop,
  "Back Office Software": FaUsers,
  "Vertical Software": FaIndustry,
  "Healthcare": FaMedkit,
  "Financial Services": FaCoins,
  "Construction & Property": FaHammer,
  "Industrial & Engineering": FaIndustry,
  "Education & Public Sector": FaGraduationCap,
  "Legal & Professional": FaFileInvoice,
  "Consumer & Nonprofit": FaHandshake,
  "Diversified Software": FaBuilding,
  "Payments & FinTech": FaCreditCard,
  "Payments & Commerce": FaBroadcastTower,
  "Payment Rails": FaMoneyBillWave,
  "Commerce Software": FaStore,
  "B2B & Banking FinTech": FaUniversity,
  "B2B Payments": FaFileInvoice,
  "Banking Infrastructure": FaUniversity,
  "Information Services": FaChartBar,
  "Financial Information": FaChartBar,
  "Market Data & Indices": FaChartBar,
  "Credit, Ratings & Risk": FaChartBar,
  "Business Information": FaChartBar,
  "Market Intelligence": FaChartBar,
  "Research & Advisory": FaChartBar,
};

export const CATEGORY_GROUP_ICONS = Object.fromEntries(
  Object.entries(CATEGORY_GROUP_ICON_COMPONENTS).map(([label, Icon]) => [label, <Icon />])
);
